/*
  ═══════════════════════════════════════════════════════════════════════
  INAKLAM — Warenkorb-Wächter für Zusatzartikel
  ═══════════════════════════════════════════════════════════════════════
  Alle Aufpreis-Artikel liegen als EIGENE Warenkorb-Zeilen im Warenkorb,
  während das, wofür sie bezahlen, als Eigenschaft am HAUPTPRODUKT hängt.
  Beide wissen nichts voneinander — daraus entstehen zwei Lücken:

   1) Hauptprodukt entfernt  -> Aufpreis-Zeilen bleiben allein stehen
      (z.B. 5 Geburtssteine für 10 € statt 5 × 9,90 €, ohne Versand)
   2) Aufpreis-Zeile entfernt -> die Leistung wäre gratis, denn die
      Eigenschaft (Stein / hochgeladenes Bild) bleibt am Hauptprodukt

  Regeln:
   • Nur Zusatzartikel im Warenkorb -> alle entfernen
   • Aufpreis-Menge ≠ Soll aus den Eigenschaften -> korrigieren

  Einhängepunkt: Dawns Ereignis PUB_SUB_EVENTS.cartUpdate (assets/cart.js).
  Bewusst NICHT als eingebettetes <script> im Warenkorb-Abschnitt: Dawn
  ersetzt diese Bereiche per innerHTML, dabei laufen <script>-Blöcke nicht
  erneut. Über pub/sub greift der Wächter auf Warenkorbseite UND im
  Warenkorb-Schubfach.

  Varianten-IDs auch in snippets/inaklam-addon-ids.liquid pflegen!
*/
(function () {
  'use strict';

  // Zählt die gewählten Geburtssteine einer Warenkorb-Zeile
  function countStones(props) {
    return parseInt(props['Anzahl Geburtssteine'], 10) || 0;
  }

  // Zählt die hochgeladenen Bilder einer Zeile. Der Konfigurator legt je Bild
  // eine eigene Eigenschaft an: "Eigenes Bild Plättchen N (Seite)[ Bild M]"
  function countImages(props) {
    var n = 0;
    for (var key in props) {
      if (
        Object.prototype.hasOwnProperty.call(props, key) &&
        key.indexOf('Eigenes Bild Plättchen') === 0 &&
        props[key]
      ) {
        n++;
      }
    }
    return n;
  }

  /*
    mode 'exact'   = Menge muss genau dem Soll entsprechen (auch nach unten korrigieren)
    mode 'minimum' = Menge darf höher sein, nur zu wenig wird aufgefüllt
    gebunden       = zählt als reiner Zusatzartikel: Zeile im Warenkorb gesperrt und
                     nicht ohne Hauptprodukt bestellbar (muss zu snippets/inaklam-addon-ids.liquid passen)
  */
  var ADDON_RULES = [
    {
      id: 53159930659082,
      label: 'Geburtsstein-Aufpreis',
      countPerItem: countStones,
      mode: 'exact',
      gebunden: true
    },
    {
      // „Spezielle Gravur" ist auch einzeln dazubuchbar (Sebastian, 28.07.2026).
      // Deshalb NUR auffüllen, nie kürzen oder entfernen — sonst würden wir
      // bewusst dazugebuchte Exemplare wegräumen.
      id: 50870800613642,
      label: 'Bild-Aufpreis (Spezielle Gravur)',
      countPerItem: countImages,
      mode: 'minimum',
      gebunden: false
    },
    {
      // Geschenkverpackung: Menge wählt der Kunde frei im Warenkorb.
      // Kein Soll aus Eigenschaften -> nur die Waisen-Regel greift.
      id: 44648941191434,
      label: 'Geschenkverpackung',
      countPerItem: null,
      mode: null,
      gebunden: true
    }
  ];

  // Nur die gebundenen Zusatzartikel dürfen nicht allein im Warenkorb liegen
  var ADDON_IDS = ADDON_RULES.filter(function (r) {
    return r.gebunden;
  }).map(function (r) {
    return r.id;
  });

  // Hinweis wird über die Adresszeile weitergereicht (überlebt das Neuladen
  // zuverlässig — anders als sessionStorage, das je nach Browser/Modus wegfällt)
  var NOTICE_PARAM = 'zusatzartikel-entfernt';

  var busy = false;

  function isAddon(item) {
    return ADDON_IDS.indexOf(item.variant_id) !== -1;
  }

  // Ermittelt, was am Warenkorb korrigiert werden muss
  function planCorrection(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return null;

    var realItems = cart.items.filter(function (item) {
      return !isAddon(item);
    });

    // Fall 1: Nur noch Zusatzartikel übrig -> komplett entfernen
    if (realItems.length === 0) {
      var removals = cart.items.filter(isAddon).map(function (item) {
        return { id: item.key, quantity: 0 };
      });
      if (!removals.length) return null;
      return {
        changes: removals,
        adds: [],
        notice: true
      };
    }

    // Fall 2: Aufpreis-Mengen stimmen nicht mit den Eigenschaften überein
    var changes = [];
    var adds = [];

    ADDON_RULES.forEach(function (rule) {
      if (!rule.countPerItem) return; // Geschenkverpackung: freie Menge

      var target = realItems.reduce(function (sum, item) {
        return sum + rule.countPerItem(item.properties || {}) * item.quantity;
      }, 0);

      var lines = cart.items.filter(function (item) {
        return item.variant_id === rule.id;
      });

      if (lines.length === 0) {
        if (target > 0) adds.push({ id: rule.id, quantity: target });
        return;
      }

      var vorhanden = lines.reduce(function (sum, l) {
        return sum + l.quantity;
      }, 0);

      if (rule.mode === 'minimum') {
        // Nur auffüllen, wenn zu wenig da ist. Mehr darf der Kunde bewusst haben.
        if (vorhanden < target) {
          changes.push({ id: lines[0].key, quantity: lines[0].quantity + (target - vorhanden) });
        }
        return;
      }

      // mode 'exact': erste Zeile auf Zielmenge, doppelte Zeilen derselben Variante auf 0
      if (lines[0].quantity !== target) {
        changes.push({ id: lines[0].key, quantity: target });
      }
      lines.slice(1).forEach(function (extra) {
        changes.push({ id: extra.key, quantity: 0 });
      });
    });

    if (!changes.length && !adds.length) return null;
    return { changes: changes, adds: adds, notice: false };
  }

  function applyChanges(plan) {
    var steps = [];

    plan.changes.forEach(function (change) {
      steps.push(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(change)
        });
      });
    });

    plan.adds.forEach(function (add) {
      steps.push(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(add)
        });
      });
    });

    // Nacheinander abarbeiten – Shopify verarbeitet Warenkorb-Änderungen seriell
    return steps.reduce(function (chain, step) {
      return chain.then(step);
    }, Promise.resolve());
  }

  function check(options) {
    if (busy) return;
    busy = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var plan = planCorrection(cart);
        if (!plan) {
          busy = false;
          return;
        }

        // Beim Hinzufügen entsteht kurzzeitig ein Zwischenstand: Produktseite und
        // Konfigurator legen Hauptprodukt und Aufpreis in zwei Schritten ab.
        // Deshalb vor dem Nachtragen einer fehlenden Zeile noch einmal prüfen.
        if (plan.adds.length && !(options && options.confirmed)) {
          busy = false;
          setTimeout(function () {
            check({ confirmed: true });
          }, 1200);
          return;
        }

        return applyChanges(plan).then(function () {
          var target = new URL(window.location.href);
          if (plan.notice) {
            target.searchParams.set(NOTICE_PARAM, '1');
          }
          window.location.replace(target.toString());
        });
      })
      .catch(function (error) {
        console.error('[inaklam] Warenkorb-Wächter:', error);
        busy = false;
      });
  }

  function showPendingNotice() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has(NOTICE_PARAM)) return;

    var message =
      'Zusatzartikel wie Geburtssteine, eigene Bildmotive oder die Geschenkverpackung ' +
      'können nur zusammen mit einem Schmuckstück bestellt werden – wir haben sie aus ' +
      'deinem Warenkorb entfernt.';

    // Kennzeichen wieder aus der Adresszeile nehmen, damit der Hinweis beim
    // nächsten Aufruf oder Teilen des Links nicht erneut erscheint.
    params.delete(NOTICE_PARAM);
    var clean =
      window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', clean);

    var box = document.createElement('div');
    box.className = 'inaklam-cart-guard-notice';
    box.setAttribute('role', 'status');
    box.textContent = message;
    document.body.appendChild(box);

    setTimeout(function () {
      box.classList.add('is-leaving');
      setTimeout(function () {
        box.remove();
      }, 400);
    }, 12000);
  }

  // Der Hinweis wird bewusst erst NACH dem vollständigen Laden eingefügt:
  // während des Seitenaufbaus eingefügte Elemente werden von nachgelagerten
  // Theme-/App-Skripten wieder aus dem Seitenkörper entfernt.
  function scheduleNotice() {
    var run = function () {
      setTimeout(showPendingNotice, 400);
    };
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run);
    }
  }

  function init() {
    scheduleNotice();
    check();

    // Bei jeder Warenkorb-Änderung erneut prüfen (Warenkorbseite + Schubfach)
    if (typeof subscribe === 'function') {
      var eventName =
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate
          ? PUB_SUB_EVENTS.cartUpdate
          : 'cart-update';
      subscribe(eventName, function () {
        check();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
